import SummaryApi from "../common/SummaryApi"

const fetchCategoryWiseProduct = async(topCategory, subCategory)=>{
    const response = await fetch(SummaryApi?.categoryWiseProduct.url(topCategory, subCategory),{
        method : SummaryApi?.categoryWiseProduct.method,
        headers : {
            "content-type" : "application/json"
        },
    })

    const dataResponse = await response.json()

    return dataResponse
}

export default fetchCategoryWiseProduct